export enum SIGNATURE_TYPE {
    WITNESS = "witness",
    AGENT = "agent",
  }
  